<template>

  <div :class="{'box-loading': loading}">

    <creating
      v-if="creating"
      height="120px" />

    <!--
    agenda já escolhida
    a agenda é definida uma única vez na conexão, para trocar é preciso
    desconectar e conectar de novo
    -->
    <div
      v-else-if="syncStarted"
      class="form-group mb-0">
      <label>{{ $t('Calendar name') }}</label>
      <div class="alert alert-secondary mb-1">{{ calendarName }}</div>
      <div class="subtext">Para usar outra agenda, remova a conexão e conecte novamente.</div>
    </div>

    <!--escolha da agenda-->
    <form
      v-else
      @submit.prevent="startSync()">

      <div class="form-group">
        <label>{{ $t('Calendar name') }}</label>
        <NoResults v-if="!calendars.length">
          {{ $t('There are no items') }}
        </NoResults>
        <div
          v-else
          class="list-group">
          <label
            v-for="(item, index) in calendars"
            :key="index"
            style="cursor: pointer;"
            class="list-group-item">
            <input
              type="radio"
              :value="item.id"
              v-model="form.calendar_id">
            {{ item.name }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.calendar_id" />
      </div>

      <div
        v-if="errorMessage"
        class="alert alert-warning">
        {{ errorMessage }}
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="loading || !form.calendar_id">{{ $t('Iniciar sincronização') }}</button>
    </form>

  </div>

</template>

<script>
export default {
  name: 'ProfileCalendarPage',
  components: {
  },
  props: {
    connection: {
      type: Object,
      required: true
    }
  },
  data () {
    // a agenda escolhida fica no connection_config
    const connectionConfig = this.connection.connection_config || {}
    return {
      creating: true,
      loading: false,
      calendars: [],
      form: {
        calendar_id: connectionConfig.calendar_id || null
      },
      // a agenda só pode ser escolhida uma vez
      syncStarted: !!connectionConfig.calendar_id,
      validateErrors: {},
      errorMessage: null
    }
  },
  computed: {
    accountId () {
      return this.$store.getters.getAccount._id
    },
    // /profile/connections/calendar/:connection_id
    url () {
      return '/accounts/' + this.accountId + '/profile/connections/calendar/' + this.connection._id
    },
    calendarName () {
      const calendar = this.calendars.find(item => item.id === this.form.calendar_id)
      return calendar ? calendar.name : (this.connection.connection_config || {}).calendar_name
    }
  },
  created () {
    // com a agenda já definida não há o que escolher
    if (this.syncStarted) {
      this.creating = false
      return
    }
    this.loadCalendars()
  },
  methods: {
    /*
    loadCalendars
    GET /profile/connections/calendar/:connection_id/capabilities/calendars
    */
    loadCalendars () {
      this.loading = true

      this.axios.get(this.url + '/capabilities/calendars')
      .then(response => {
        this.calendars = response.data.docs || response.data

        // por padrão vem selecionada a agenda principal
        const primary = this.calendars.find(item => item.is_primary)
        if (!this.form.calendar_id && primary) {
          this.form.calendar_id = primary.id
        }
      })
      .catch(err => {
        this.errorMessage = this.messageOf(err)
      })
      .then(() => {
        this.creating = this.loading = false
      })
    },
    /*
    startSync
    inicia a sincronização com a agenda escolhida

    POST /profile/connections/calendar/:connection_id/capabilities/sync
    */
    async startSync () {
      this.loading = true
      this.validateErrors = {}
      this.errorMessage = null

      try {
        await this.axios.post(this.url + '/capabilities/sync', {
          calendar_id: this.form.calendar_id
        })

        this.syncStarted = true
        this.$emit('updated')
      } catch (err) {
        const data = err.response && err.response.data
        if (data && data.name === 'ValidationError') {
          this.validateErrors = data.errors
        } else {
          this.errorMessage = this.messageOf(err)
        }
      } finally {
        this.loading = false
      }
    },
    messageOf (err) {
      const data = err.response && err.response.data
      return (data && data.message) || this.$t('Something went wrong')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProfileCalendarSettings/Page.vue